module.exports = __webpack_public_path__ + "img/skillsC-3.4f0b475c.png";